module.exports = __webpack_public_path__ + "static/media/me_small@3x.aa82843d.jpg";